import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EndDateInFuture } from 'src/app/core/validators/end-date-in-future.validator';

export interface ReactivateWithEndDateDialogData {
  title: string;
  message: string;
  data : string;
  endDate: Date;
  confirm: string;
  cancel: string;
}

export class ReactivateWithEndDateDialogDataResult {
  endDate: Date;
}

@Component({
    selector: 'app-reactivate-with-end-date-dialog',
    templateUrl: './reactivate-with-end-date-dialog.component.html',
    styleUrl: './reactivate-with-end-date-dialog.component.scss',
    standalone: false
})
export class ReactivateWithEndDateDialogComponent {
  reactivateWithEndDateFormGroup: UntypedFormGroup;
  minEndDate : Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<ReactivateWithEndDateDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ReactivateWithEndDateDialogData
  ) {

    this.minEndDate.setHours(0, 0, 0, 0);
    this.minEndDate.setDate(this.minEndDate.getDate() + 1);

    if (data.confirm === null || data.confirm === undefined) {
      data.confirm = "Ok";
    }

    if (data.cancel === null || data.cancel === undefined) {
      data.cancel = "Cancel";
    }
  }

  ngOnInit(): void {
    this.reactivateWithEndDateFormGroup = this.formBuilder.group({
      'reactivateEndDate': ['', [Validators.required]]
    }, {
      validator: EndDateInFuture('reactivateEndDate')
    });

    if (this.data.endDate) {
      const reactivateEndDate = new Date(this.data.endDate);

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (reactivateEndDate < today) {
        today.setFullYear(today.getFullYear() + 1);
        this.reactivateWithEndDateFormGroup.patchValue({ 'reactivateEndDate': today });
      }
      else {
        this.reactivateWithEndDateFormGroup.patchValue({ 'reactivateEndDate': reactivateEndDate });
      }
    }
  }

  onCancelClick(): void {
    const result = new ReactivateWithEndDateDialogDataResult();
    result.endDate = null;
    this.dialogRef.close(result);
  }

  onConfirmClick(): void {
    if (this.reactivateWithEndDateFormGroup.valid) {
      const result = new ReactivateWithEndDateDialogDataResult();
      result.endDate = this.reactivateWithEndDateFormGroup.controls.reactivateEndDate.value;
      this.dialogRef.close(result);
    }
  }
}
